module.exports = __webpack_public_path__ + "img/list_Portrait_05.3ee4622e.jpeg";